import Vue from 'vue';

export const componentPath = (vm: Vue, path = ''): string => {
  path += vm.constructor.name + ' -> ';

  if (vm.$parent) {
    return componentPath(vm.$parent, path);
  }
  return path.substr(0, path.lastIndexOf('Vue ->') - 4);
};

export const PROGRESS_BAR_CONFIG = {
  color: '#3A7BC7',
  failedColor: 'red',
  height: '2px',
};

export const TOASTR_CONFIG = {
  defaultPosition: 'toast-bottom-left',
  defaultStyle: {
    'border-radius': '5px',
    'background': 'white',
    'opacity': '1.0',
    'padding-bottom': '20px',
  },
  defaultTimeout: 5000,
  defaultClassNames: ['animated', 'zoomInUp'],
  defaultProgressBar: false,
};
